export enum DictionaryGroup {
   AREA = 'area',
   PROJECT = 'project'
}
//TODO: szerintem jobb lenne, ha a backend leküldené... skálázhatóbb..
